var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4612df4c-1cfa-4b28-a190-5d5752f826d3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 578 578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-402daa77-af3a-4023-95f1-07332528e51e{fill:#fff;}.uuid-e0bd20af-e5c5-4335-b499-b4dca5a56441{fill:#bebec0;}.uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77{fill:none;stroke:#1d1d1b;stroke-linecap:round;stroke-linejoin:round;stroke-width:16.9px;}.uuid-1f8a78e0-cff1-430d-8532-67c2ea9b1784{fill:#dadada;}.uuid-c2bb4e26-c544-4ec7-9688-abdc6bd99ba2{fill:#878787;}.uuid-f4a86353-7b36-4b40-972d-f54f374e90d4{fill:#3b368b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-402daa77-af3a-4023-95f1-07332528e51e",
    d: "M68.4,196.8c3.9-6,10.2-9.8,16.3-13.5,11.9-7.2,28.5-13.9,38.3-4,1.9,1.9,3.4,4.4,5.7,5.8,4,2.4,9.2,1,13.6-.5,55.2-18.6,109.3-40.4,162-65.2-5.7-7.9-2.9-19.5,3.8-26.5,6.7-7,16.4-10.2,25.8-12.4,8.6-2,19.2-2.9,24.9,4,1.8,2.1,2.8,4.8,4.7,6.8,6.3,6.6,17.1,2.9,26.1,2.3,23.3-1.7,41.1,19.5,54.7,38.5,27.9,39.1,55.8,78.3,83.7,117.4,5.5,7.7,11.2,15.7,13.6,24.9,2.7,10,1.5,20.7-1.7,30.6-8.4,26.2-30.2,47.2-56,56.5-8.1,2.9-16.8,4.7-25.2,2.8-5.7-1.3-10.8-4.3-15.8-7.3-19.8-11.7-41.1-25.2-47.9-47.1-16.1,15.2-36.1,31.5-57.7,26.5-12.5-2.9-22.3-12.7-29.6-23.3-2.1-3-4.3-6.3-7.8-7.1-2.7-.6-5.4,.4-8,1.3-8.2,3.1-16.5,6.2-24.7,9.3,3.8,18.8-1.8,39.2-14.6,53.5-12.8,14.3-32.5,22-51.6,20.4,8.4,27.9,2.3,60.4-18,81.3-20.2,20.9-54.6,27.7-80,13.6-28.3-15.7-39.4-50.3-46.4-81.9-9.8-44.4-16.5-89.5-19.9-134.9-.9-11.4-1.4-23.3,3.2-33.8,5.1-11.6,14.1-9.8,21.3-16.9,6.3-6.2,2.1-13.3,7-21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1f8a78e0-cff1-430d-8532-67c2ea9b1784",
    d: "M190.6,291.4c-6.5,1.6-13.3,3.4-18,8.1-5.8,5.9-7,14.8-7.3,23.1-.3,10.2,.3,20.4,1.9,30.5,1.1,7,2.7,14.1,6.5,20.1,5.4,8.5,14.9,13.8,24.7,16,26,5.9,55.1-11,62.9-36.5,6.4-20.9-2.2-42.5-17.4-57.1-15.7-15-33.6-9.1-53.2-4.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1f8a78e0-cff1-430d-8532-67c2ea9b1784",
    d: "M298.3,263.7c-2.6,6.2-2.6,13.2-2.4,19.9,.2,9.2,.7,18.7,4.6,27,5.4,11.2,16.8,18.8,29,21.1,12.2,2.3,25-.2,36.3-5.3,10.1-4.6,19.7-11.7,24.3-21.9,4-8.7,3.9-18.7,2.3-28-3.5-19.7-19.2-46.5-42.4-45.8-16.3,.5-45.3,18.1-51.6,32.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c2bb4e26-c544-4ec7-9688-abdc6bd99ba2",
    d: "M220,316.8c-6.3,.2-12.7,1.8-17.5,5.8-4.8,4-7.6,10.8-5.6,16.8,.8,2.5,2.4,4.7,4.2,6.7,2.9,3.3,6.5,6.2,10.7,7.5,10,3.2,22-4.5,23.2-15,1.2-10.5-8.7-20.7-19.1-19.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c2bb4e26-c544-4ec7-9688-abdc6bd99ba2",
    d: "M346.2,262.4c-8.8,1.1-17.5,5.6-21.9,13.3-4.4,7.7-3.6,18.5,3.1,24.3,1.8,1.5,3.9,2.7,6,3.6,5.7,2.4,12.2,3.3,18.2,1.5,5.9-1.8,11.2-6.4,12.8-12.4,1.4-5.2,0-10.8-1.8-15.9-1.5-4.3-3.5-8.7-7-11.7s-8.8-4.3-12.7-2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1f8a78e0-cff1-430d-8532-67c2ea9b1784",
    d: "M117.7,201.9c-16.9,6.3-33.3,14.1-48.9,23.1-10.8,6.3-21.9,13.8-26.7,25.4-4,9.6-3.1,20.5-2.1,30.8,4.2,43.1,9.2,86.1,14.8,129.1,3.6,27.2,9.4,57.8,32.3,73,15.5,10.3,35.2,10.9,53.8,11.1,6.7,0,13.6,.1,20.1-1.5,17.1-4.4,29.4-20.3,34.4-37.3,5-17,4-35,3-52.7-.3-5.7-.8-11.7-4.1-16.2-2.5-3.3-6.2-5.5-9.6-7.9-13-9.1-22.5-23.7-24.1-39.5-1.6-15.8,5.3-32.6,18.4-41.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1f8a78e0-cff1-430d-8532-67c2ea9b1784",
    d: "M446.8,291.4c9.6-5.3,20-9.1,29.4-14.8,15.6-9.4,28.9-24.2,46.8-27.3,7.9,13,13,27.8,14.9,42.9,.8,6.4,1,13-.7,19.2-1.6,5.7-4.7,10.9-7.7,15.9-4,6.6-8,13.2-13.1,18.9-13.8,15.6-36.4,23.7-56.4,17.9-8.8-2.5-16.7-7.4-24.3-12.5-9.8-6.5-26.9-16.1-22.7-29.9,3.8-12.6,23.1-24.5,33.8-30.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e0bd20af-e5c5-4335-b499-b4dca5a56441",
    d: "M88.9,479.6c13.6,13,32.3,21.2,51,19.7,18.7-1.5,35.9-12.6,46.9-27.7,11.1-15.1,16.5-33.9,17.6-52.6,.1-1.9,.1-4-1-5.5-1.8-2.4-5.5-2.2-8.5-1.7-33.7,5.6-67.3,11.1-101,16.7-10,1.7-28.7,.4-29.5,12.7-.7,11.6,16.8,30.9,24.5,38.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c2bb4e26-c544-4ec7-9688-abdc6bd99ba2",
    d: "M104.2,177.6c-10.9,2.4-20.3,8.8-30.3,13.9-2.1,1.1-4.3,2.1-6,3.9-3.9,4.3-3,11-1.9,16.7,3.8,1.5,8.1,.2,12-1.2,10.4-3.6,44.6-9.4,50.1-18.9,8-13.7-16-16.2-24-14.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c2bb4e26-c544-4ec7-9688-abdc6bd99ba2",
    d: "M361.1,78.5c-1.7-.6-3.6-.4-5.4-.2-11.1,1.3-22.4,3.2-32.2,8.6-4.5,2.5-8.7,5.8-12.7,9-3.9,3.1-7.9,6.3-10.6,10.5-2.7,4.2-3.8,9.8-1.6,14.2,1.3,2.7,4,4.9,7,4.9,1.7,0,3.4-.7,5-1.3,15.9-6.6,35.7-9.7,50.5-17.9s14.5-22.4,.1-27.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c2bb4e26-c544-4ec7-9688-abdc6bd99ba2",
    d: "M175.8,243.1c2.1,3.6,4.6,7.2,8.3,9.1,3.5,1.8,7.5,1.7,11.4,1.5,38.1-2.5,72.7-22.3,105.6-41.7,2.1-1.2,4.2-2.5,5.7-4.4,2.2-2.7,2.9-6.4,2.7-9.9-.2-6.8-3-13.2-5.7-19.5-6.5-14.8-13-29.7-19.5-44.5-35.1,17.7-71.5,28.4-108.3,41.5-34.4,12.3-14.5,44.1-.2,67.9Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    d: "M78.7,243.3l22.3-9c3.7-1.5,7.8,.3,9.3,4l3.8,9.3c.7,1.8,.7,3.7,0,5.5l-6.7,15.7c-1.5,3.6-5.7,5.3-9.4,3.8l-15.8-6.7c-1.8-.8-3.2-2.2-3.9-4l-3.6-9.3c-1.4-3.6,.4-7.7,4-9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    d: "M134.5,318l-22.3,9c-3.7,1.5-7.8-.3-9.3-4l-3.8-9.3c-.7-1.8-.7-3.7,0-5.5l6.7-15.7c1.5-3.6,5.7-5.3,9.4-3.8l15.8,6.7c1.8,.8,3.2,2.2,3.9,4l3.6,9.3c1.4,3.6-.4,7.7-4,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    d: "M143.9,252.8l9,22.3c1.5,3.7-.3,7.8-4,9.3l-9.3,3.8c-1.8,.7-3.7,.7-5.5,0l-15.7-6.7c-3.6-1.5-5.3-5.7-3.8-9.4l6.7-15.8c.8-1.8,2.2-3.2,4-3.9l9.3-3.6c3.6-1.4,7.7,.4,9.2,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    d: "M69.3,308.5l-9-22.3c-1.5-3.7,.3-7.8,4-9.3l9.3-3.8c1.8-.7,3.7-.7,5.5,0l15.7,6.7c3.6,1.5,5.3,5.7,3.8,9.4l-6.7,15.8c-.8,1.8-2.2,3.2-4,3.9l-9.3,3.6c-3.6,1.4-7.7-.4-9.2-4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    cx: 374.5,
    cy: 140.8,
    r: 18.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    cx: 396.7,
    cy: 195.7,
    r: 18.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    cx: 413,
    cy: 157.2,
    r: 18.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f4a86353-7b36-4b40-972d-f54f374e90d4",
    cx: 358.2,
    cy: 179.3,
    r: 18.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    x1: 528.4,
    y1: 249.5,
    x2: 408,
    y2: 327.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    cx: 345.2,
    cy: 284.4,
    r: 51.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    cx: 345.2,
    cy: 284.4,
    r: 21.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    d: "M304.2,125.4l-2.3-5.8c-4.3-10.6,.9-22.8,11.5-27l27.2-11c10.6-4.3,22.8,.9,27,11.5l2.3,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    d: "M458.9,153.1l69.6,96.4c24.1,33.4,14.9,80.3-20.1,102.1h0c-30.3,18.9-70,12.4-92.7-15.2l-24-29.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    d: "M187.8,469.4c-10,14.4-25.4,25.1-43.7,29h0c-40.3,8.6-79.5-18.8-85.3-59.7l-23.5-165.4c-3.1-22,9.2-43.2,29.7-51.5l150.2-60.5,8.1-3.3,150.2-60.5c20.6-8.3,44.2-1.5,57.2,16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    d: "M197.4,385.4l3,37.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    x1: 58.8,
    y1: 438.8,
    x2: 199.4,
    y2: 411.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    cx: 215,
    cy: 336.8,
    r: 51.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    cx: 215,
    cy: 336.8,
    r: 21.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    d: "M150.4,187.4l21.5,53.5c5.3,13.2,20.4,19.7,33.6,14.3l40.9-16.5,8.1-3.3,40.9-16.5c13.2-5.3,19.7-20.4,14.3-33.6l-21.5-53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    d: "M134.4,193.9l-2.3-5.8c-4.3-10.6-16.4-15.8-27-11.5l-27.2,11c-10.6,4.3-15.8,16.4-11.5,27l2.3,5.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-4ddeefc0-2c1f-46d1-b5b7-50df6942bd77",
    x1: 268.2,
    y1: 315.4,
    x2: 297.2,
    y2: 303.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.3d1d3d737f5719698a3fb940c3aa4c0a.svg";
export { ForwardRef as ReactComponent };